import { call, put, takeLatest } from 'redux-saga/effects'
import { sagaActions } from '../sagaActions'
import { FixTypeLater } from 'react-redux'
import { AxiosResponse } from 'axios'
import { ResponseStructure, callAPI, HttpMethod } from '.'

import {
  fetchViewTicket,
  fetchViewTicketSuccess,
  fetchViewTicketFailure,
  ResponseViewTicketData,
} from '../reducers/viewTicketReducer'
import { parseTheme } from '@/ui-components/utils/theme-utils'

const API_FETCH_VIEW_TICKET = `${import.meta.env.VITE_HOST}/api/v1/seamless/viewTicket/:transactionId`

interface ResponseViewTicket extends ResponseStructure {
  data: ResponseViewTicketData
}

function* doFetchViewTicket({
  payload: { transactionId },
}: {
  payload: { transactionId: string }
}) {
  try {
    yield put(fetchViewTicket())
    const result: AxiosResponse<ResponseViewTicket> = yield call(() =>
      callAPI({
        url: API_FETCH_VIEW_TICKET.replace(':transactionId', transactionId),
        method: HttpMethod.GET,
      }),
    )
    if (result?.data?.status === 'OK') {
      // Just make sure theme is parsed
      if (result?.data?.data && result?.data?.data?.theme) {
        result!.data!.data!.theme = parseTheme(result?.data?.data?.theme)
      }

      yield put(fetchViewTicketSuccess(result?.data?.data))
    } else {
      yield put(fetchViewTicketFailure(result?.data?.message))
    }
  } catch (e: FixTypeLater) {
    yield put(fetchViewTicketFailure(e.response?.data?.message ?? e.message))
  }
}

export function* watchViewTicket() {
  yield takeLatest<FixTypeLater>(
    sagaActions.FETCH_VIEW_TICKET,
    doFetchViewTicket,
  )
}
